import { MinimalCountryAccomodationType } from 'app/constants/configuration/minimalCountryAccomodationType'

export const getMinimalCountryAccomodationTypeName = (
  minimalCountryAccomodationType: MinimalCountryAccomodationType,
  translate: (string) => string,
): string => {
  const text: string =
    MinimalCountryAccomodationType[minimalCountryAccomodationType]
  return translate(`minimalCountryAccomodationType.${text}`)
}
